module.exports = __webpack_public_path__ + "static/media/akiba.e07e1641.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/akiba.jpg
// module id = 197
// module chunks = 0